<template>
	<TheHeader></TheHeader>

	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>

					<ThePageLoading :pageTitle="''" v-if="isPageLoading"></ThePageLoading>

					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader :pageTitle="pageError != '' ? '' : '[' + this.journalEntity.journal.consoGroupName + '] ' + this.journalEntity.id"></ThePageHeader>

						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">
								<div class="row mb-2">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Journal ID:</label>
									</div>

									<div class="col-md-6">
										<InputText class="journal-entity-cell" v-model="journalEntity.id" maxlength="50" placeholder="Journal ID" :disabled="journalEntity.journal.status == 'Consolidated'"/>
									</div>
								</div>

								<div class="row mb-2">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Date:</label>
									</div>

									<div class="col-md-6">
										<Calendar class="journal-entity-cell" dateFormat="yy-mm-dd" :manualInput="true" placeholder="Date" v-model="journalEntity.date" :disabled="journalEntity.journal.status == 'Consolidated'" />
									</div>
								</div>

								<div class="row mb-2">
									<div class="col-md-3">
										<label class="col-form-label-title">Entity:</label>
									</div>

									<div class="col-md-6">
										<Dropdown class="journal-entity-cell" :options="companies" optionLabel="code" filter showClear :placeholder="isCompanyLoading ? ('Loading...') : '-- Please Select --'" :loading="isCompanyLoading" v-model="journalEntity.company" :autoOptionFocus="true" :filterFields="['code', 'name']" :disabled="journalEntity.journal.status == 'Consolidated'">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="flex align-items-center">
													<span class="col-md-3">{{ slotProps.value.code }}</span>
													<span class="col-md-9">{{ slotProps.value.name }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
									</div>
								</div>

								<div class="row mb-2">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Description:</label>
									</div>

									<div class="col-md-9">
										<InputText class="journal-entity-cell" v-model="journalEntity.description" maxlength="255" placeholder="Description" :disabled="journalEntity.journal.status == 'Consolidated'"></InputText>
									</div>
								</div>

								<div class="row mb-2">
									<div class="col-md-3">
										<label class="col-form-label-title">Remarks:</label>
									</div>

									<div class="col-md-9">
										<Textarea v-model="journalEntity.remarks" rows="2" cols="50" placeholder="Remarks" :disabled="journalEntity.journal.status == 'Consolidated'"/>
									</div>
								</div>

								<div class="row mb-1">
									<Divider />
								</div>

								<div class="row mb-2">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Accounts:</label>
									</div>

									<div class="col-md-6">
										<Dropdown class="journal-entity-cell" :virtualScrollerOptions="{ itemSize: 50 }" :options="accounts" filter showClear placeholder="-- Please Select --" v-model="account" :filterFields="['code', 'description']" :resetFilterOnHide="true" :disabled="journalEntity.journal.status == 'Consolidated'">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="row ">
													<span class="col-md-2">{{ slotProps.value.code }}</span>
													<span class="col-md-10">{{ slotProps.value.description != null ?  slotProps.value.description : '' }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="row ">
													<span class="col-md-2">{{ slotProps.option.code }}</span>
													<span class="col-md-10">{{ slotProps.option.description != null ?  slotProps.option.description : '' }}</span>
												</div>
											</template>
										</Dropdown>
									</div>

									<div class="d-flex col-md-3">
										<Button class="journal-entity-cell mr-2" icon="pi pi-plus" @click="addAccount(false)" :disabled="account == null || journalEntity.journal.status == 'Consolidated'" />
										<Button class="journal-entity-cell mr-2" icon="pi pi-search" @click="openAdvancedSearchDialog" severity="warning" label="Advanced" :disabled="journalEntity.journal.status == 'Consolidated'"></Button>
									</div>
								</div>

								<div class="row mb-2">
									<DataTable class="journal-table" :value="journalEntity.journalEntityAccounts" responsiveLayout="scroll" selectionMode="single" paginator paginatorPosition="bottom" :rows="20">
										<Column style="width: 10%;" field="accountCode" header="Code"></Column>
										
										<Column style="width: 50%;" header="Description">
											<template #body="slotProps">
												{{ slotProps.data.accountDescription != null ? slotProps.data.accountDescription : '' }}
											</template>
										</Column>

										<Column style="width: 15%;" field="accountDr" header="DR">
											<template #body="slotProps">
												<InputNumber class="journal-entity-cell number" v-model="slotProps.data.accountDr" mode="decimal" :maxFractionDigits="0" :disabled="journalEntity.journal.status == 'Consolidated'"/>
											</template>
										</Column>
										
										<Column style="width: 15%;" field="accountCr" header="CR">
											<template #body="slotProps">
												<InputNumber class="journal-entity-cell number" v-model="slotProps.data.accountCr" mode="decimal" :maxFractionDigits="0" :disabled="journalEntity.journal.status == 'Consolidated'"/>
											</template>
										</Column>

										<Column style="width: 10%" header="">
											<template #body="slotProps">
												<Button icon="pi pi-trash" severity="danger" text rounded @click="removeAccount(slotProps.index)" title="Remove" :disabled="journalEntity.journal.status == 'Consolidated'" :hidden="isViewer" />
											</template>
										</Column>

										<template #empty>
											<div class="error-no-record mt-3" v-if="journalEntity.journalEntityAccounts.length <= 0">
												<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
												<h6><span>No Record Found</span></h6>
											</div>
										</template>

										<template #footer v-if="journalEntity.journalEntityAccounts.length > 0">
											<div class="row">
												<div class="col-md-4">
													<span>Total Debit: {{ totalDebit.toLocaleString() }}</span>
												</div>
												
												<div class="col-md-4">
													<span>Total Credit: {{ totalCredit.toLocaleString() }}</span>
												</div>
												
												<div class="col-md-4">
													<span :style="totalDifference != 0 ? 'color:red' : ''">Difference: {{ totalDifference.toLocaleString() }}</span>
												</div>
											</div>
										</template>
									</DataTable>
								</div>

								<div class="row mb-2">
									<div class="col-md-3"></div>

									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.journalEntity.$invalid || isLoading || totalDifference!=0 || journalEntity.journal.status == 'Consolidated'" :hidden="isViewer" @click="entityId == null ? save() : update()" label="Save" />
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel" />
										<span class="p-1"></span>

										<TheLoading v-if="isLoading"></TheLoading>
									</div>
								</div>
							</div>
						</div>

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>

					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>

	<Dialog class="advanced-search-dialog" v-model:visible="advanceSearchDialog.visible" modal :draggable="false" header="Advanced Search" style="width:55vw; height:75vh" @hide="closeAdvancedSearchDialog" >
		<DataTable paginator :first="0" :rows="10" v-model:selection="account" :value="filteredAccount" dataKey="identifier" @page="resetScroll" @rowClick="selectAccount" :rowClass="()=>'clickable'">
			<Column style="width:15%" field="code" header="Code"></Column>
			<Column header="Description">
				<template #body="slotProps">
					{{ slotProps.data.description != null ? slotProps.data.description : '' }}
				</template>
			</Column>

			<template #empty>
				<div class="error-no-record" v-if="filteredAccount.length <= 0">
					<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
					<h6><span>No Record Found</span></h6>
				</div>
			</template>
		</DataTable>

		<template #footer>
			<div class="row mb-1 text-left">
				<div class="col-md-12">
					<Checkbox v-model="advanceSearchDialog.isShowBoth" inputId="advanceSearchShowBoth" :binary="true" @change="filterAccount" />
					<label for="advanceSearchShowBoth" class="ml-2"> Showing items containing '{{ advanceSearchDialog.filterA }}' and '{{ advanceSearchDialog.filterB }}' </label>
				</div>
			</div>

			<div class="row mb-1 text-left">
				<label>To show items containing the following text:</label>
			</div>

			<div class="row mb-2">
				<div class="col-md-4">
					<InputText v-model="advanceSearchDialog.filterA" @keyup="filterAccount"></InputText>
				</div>

				<div v-if="advanceSearchDialog.isShowBoth" class="col-md-1 text-center align-self-center">
					<label>AND</label>
				</div>

				<div v-else class="col-md-1 text-center align-self-center">
					<label>OR</label>
				</div>

				<div class="col-md-4">
					<InputText v-model="advanceSearchDialog.filterB" @keyup="filterAccount"></InputText>
				</div>

				<div class="col-md-3">
					<Button icon="pi pi-plus" label="Add" @click="addAccount(true)" :disabled="account == null"></Button>
				</div>
			</div>
		</template>
	</Dialog>

</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import journalEntityApi from "@/api/journalentity-api";
	import companyApi from "@/api/company-api";
	import accountApi from "@/api/account-api";
	import roleMixin from "@/mixin/role";
	import dateUtilsMixin from "@/mixin/utils/date-utils";

	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";

	import useVuelidate from "@vuelidate/core";
	import { helpers, required, requiredIf } from "@vuelidate/validators";

	export default defineComponent({
		mixins: [roleMixin, dateUtilsMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				journalId: useRoute().params.id,
				entityId: useRoute().params.entityId,
				journalEntity: {journal: {identifier: null, consoGroupId: null, date: null, status: null}, identifier: null, id: null, company: null, companyCode: null, date: null as any, description: null, remarks: null, journalEntityAccounts: [] as any[], isClosed: false},
				companies: [] as any[],
				accounts: [] as any[],
				filteredAccount: [] as any[],
				account: null as any,
				isPageLoading: false,
				isLoading: false,
				isCompanyLoading: false,
				advanceSearchDialog: {visible: false, filterA: '', filterB: '', isShowBoth: false},
			}
		},
		computed: {
			// isAccountExists() {
			// 	if (this.account != null) {
			// 		var journalAccounts = this.journalEntity.journalEntityAccounts.filter((journalAccount: any, index: any) => {
			// 			if (journalAccount.accountCode == this.account.code) {
			// 				return journalAccount;
			// 			}
			// 		});
			// 		return (journalAccounts != null && journalAccounts.length > 0 ? true : false);
			// 	}
			// 	return true;
			// },
			totalCredit() {
				let total = 0;
				if (this.journalEntity != null && this.journalEntity.journalEntityAccounts != null && this.journalEntity.journalEntityAccounts.length > 0) {
					this.journalEntity.journalEntityAccounts.forEach(account => {
						// if (account.accountCr == 0) {
						// 	account.accountCr = null;
						// }
						total += account.accountCr;
					})
				}
				return total;
			},
			totalDebit() {
				let total = 0;
				if (this.journalEntity != null && this.journalEntity.journalEntityAccounts != null && this.journalEntity.journalEntityAccounts.length > 0) {
					this.journalEntity.journalEntityAccounts.forEach(account => {
						// if (account.accountDr == 0) {
						// 	account.accountDr = null;
						// }
						total += account.accountDr;
					})
				}
				return total;
			},
			totalDifference() {
				return this.totalCredit - this.totalDebit;
			},
			// isInvalid() {
			// 	if (this.journalEntity != null && this.journalEntity.journalEntityAccounts != null && this.journalEntity.journalEntityAccounts.length > 0) {
			// 		var journalEntityAccounts = this.journalEntity.journalEntityAccounts.filter(function (journalEntityAccount: any) {
			// 			if (journalEntityAccount.accountDr == null && journalEntityAccount.accountCr == null) {
			// 				return journalEntityAccount;
			// 			}
			// 		});
			// 		if (journalEntityAccounts != null && journalEntityAccounts.length > 0) {
			// 			return true;
			// 		}
			// 	}
			// 	return false;
			// },
		},
		mounted: function () {
			if (this.pageError == '') {
				this.isPageLoading = true;

				let r1 = accountApi.accountList({});

				let r2 = journalEntityApi.journalEntityView(this.journalId, this.entityId)
					.catch(error => {
						this.pageError = error;
						this.isPageLoading = false;
					})

				Promise.all([r1, r2])
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == 0) {
												this.accounts = values[i].data.listSet;
												this.filteredAccount = this.accounts;
											}

											else if (i == 1) {
												this.journalEntity = values[i].data.journalEntity;
												if (this.journalEntity != null && this.journalEntity.date != null) {	
													this.journalEntity.date = this.formatToDate(this.journalEntity.date);
												}
												if (this.journalEntity != null && this.journalEntity.journal != null) {
													companyApi.companyList({}, null)
														.then((response: any) => {
															this.companies = response.data.listSet
														})
														.catch((error) => {
															this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
														});
												}
											}
										}
									}
								}
							}
						}
						this.isPageLoading = false;
					})
					.catch(error => {
						this.isPageLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			}
		},
		methods: {
			save() {
				this.isLoading = true;

				if (this.journalEntity.date != null && (this.journalEntity.date instanceof Date)) {
					this.journalEntity.date = this.formatToDate(this.journalEntity.date);
				}
				
				journalEntityApi.journalEntitySave({
						journalEntity: this.journalEntity
					})
					.then((response: any) => {
						this.isLoading = false;
						this.$toast.add({severity: "success", summary: "Success.", detail: response.message, life: 6000});
						this.$router.push("/journal/" + this.journalId);

					})
					.catch((error) => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				this.isLoading = true;
				
				if (this.journalEntity.date != null && (this.journalEntity.date instanceof Date)) {
					this.journalEntity.date = this.formatToDate(this.journalEntity.date);
				}

				journalEntityApi.journalEntityUpdate({
						journalEntity: this.journalEntity
					})
					.then((response: any) => {
						this.isLoading = false;
						this.$toast.add({severity: "success", summary: "Success.", detail: response.message, life: 6000});
						this.$router.push("/journal/" + this.journalId);
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			cancel() {
				this.$router.push("/journal/" + this.journalId);
			},
			addAccount(isAdvanceSearch: any) {
				if (isAdvanceSearch) {
					this.closeAdvancedSearchDialog();
				}

				this.journalEntity.journalEntityAccounts.push({identifier: null, accountId: this.account.identifier, accountCode: this.account.code, accountType: this.account.type, accountDescription: this.account.description, accountCr: null, accountDr: null});
				this.account = null;
			},
			removeAccount(index: any) {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to remove this account?',
					icon: 'pi pi-trash',
					accept: () => {
						this.journalEntity.journalEntityAccounts.splice(index, 1);
					}
				});
			},
			openAdvancedSearchDialog() {
				this.advanceSearchDialog.visible = true;
				document.body.classList.add("dialog-open");
			},
			closeAdvancedSearchDialog() {
				this.advanceSearchDialog.visible = false;
				this.advanceSearchDialog.isShowBoth = false;
				this.advanceSearchDialog.filterA = '';
				this.advanceSearchDialog.filterB = '';
				this.filteredAccount = this.accounts;
				document.body.classList.remove("dialog-open");
			},
			filterAccount() {
				this.account = null as any;

				if ((this.advanceSearchDialog.filterA == null || this.advanceSearchDialog.filterA == "") && (this.advanceSearchDialog.filterB == null || this.advanceSearchDialog.filterB == "")) {
					this.filteredAccount = this.accounts;
				}

				else {
					if (this.advanceSearchDialog.isShowBoth) {
						this.filteredAccount = this.accounts.filter((account: any) =>
							this.filterCondition(account, this.advanceSearchDialog.filterA.trim().toLowerCase()) && this.filterCondition(account, this.advanceSearchDialog.filterB.trim().toLowerCase())
						);
					}

					else {
						this.filteredAccount = this.accounts.filter((account: any) =>
							this.filterCondition(account, this.advanceSearchDialog.filterA.trim().toLowerCase()) || this.filterCondition(account, this.advanceSearchDialog.filterB.trim().toLowerCase())
						);
					}
				}
			},
			filterCondition(account: any, key: any) {
				if (key == null || key =='') {
					return false;
				}

				else {
					return (account.code.toLowerCase().indexOf(key) >= 0) || (account.description?.toLowerCase().indexOf(key) >= 0);
				}
			},
			resetScroll(){
				document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
			},
			selectAccount(event:any){
				if (this.account != null && this.account == event.data) {
					this.account = null;
				}

				else {
					this.account = event.data;
				}
			}
		},
		setup() {
			return {v$: useVuelidate()}
		},
		validations() {
			return {
				journalEntity: {
					journal: {
						identifier: {
							required
						},
					},
					id: {
						required
					},
					date: {
						required
					},
					description: {
						required
					},
					journalEntityAccounts: {
						required
					}
				},
			}
		}
	})
</script>